import { Game } from '../../background/models/game.model';
import { Promotion } from '../../background/models/promotion.model';
import { IExposableService } from '../../background/services/external-services-exposer.service';

// -----------------------------------------------------------------------------
export const kNameOfTesterWindowService = 'TesterWindowService';

// -----------------------------------------------------------------------------
export interface ITesterWindowService extends IExposableService {
  transferTesterPromotion(
    game: Game,
    promotion: Promotion,
    environment: string,
  );
  resetLocalStorage();
  resetPromotionsHistory();
  getGlobalConfigurations();
  getAllGamesConfigurations();
  getGameConfiguration(gameId: number);
  IsPromotionRunning();
  resetDisplayedPromotions();
  setEnvironment(environment: string): Promise<boolean>;
}
